module.exports = __webpack_public_path__ + "img/star.16ffb00e.svg";